import usePageMeta from '../lib/usePageMeta';
import PageHero from '../components/PageHero';
import Contact from '../components/Contact';
import Icon from '../components/Icon';
import { SectionHead, FaqList } from '../components/Blocks';
import { FAQS } from '../data';

const NEXT = [
  { icon: 'mail', title: 'We review your brief', desc: 'A specialist reads your message and prepares the right questions.' },
  { icon: 'phone', title: 'Free discovery call', desc: 'A 30-minute call to understand goals, timeline and budget.' },
  { icon: 'chart', title: 'Proposal in 1–2 days', desc: 'A clear scope, timeline and fixed quote — no obligation.' },
];

export default function ContactPage() {
  usePageMeta('Contact Us', 'Contact Origo Private Limited for a free consultation and quote on your website, app, design, animation or marketing project.');

  return (
    <>
      <PageHero
        eyebrow="Contact"
        title="Tell us about your project"
        description="Share a few details and we will reply within one business day with next steps and a free estimate."
        crumbs={[{ label: 'Contact' }]}
      />

      <section className="section bg-brand-soft">
        <div className="container-x"><Contact /></div>
      </section>

      <section className="section bg-white">
        <div className="container-x">
          <SectionHead eyebrow="What happens next" title="Three simple steps after you get in touch" />
          <div className="mt-12 grid gap-6 md:grid-cols-3" data-anim="up" data-stagger>
            {NEXT.map((n, i) => (
              <div key={n.title} className="lift rounded-3xl border border-brand/10 bg-brand-soft/60 p-8">
                <span className="grid h-14 w-14 place-items-center rounded-2xl bg-brand text-white"><Icon name={n.icon} className="h-7 w-7" /></span>
                <p className="mt-5 font-display text-sm font-bold text-brand">STEP {i + 1}</p>
                <h3 className="mt-1 text-xl font-bold text-ink">{n.title}</h3>
                <p className="mt-2 text-slate-600">{n.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section bg-brand-soft">
        <div className="container-x grid gap-14 lg:grid-cols-[.8fr_1.2fr]">
          <div data-anim="left">
            <span className="eyebrow">FAQ</span>
            <h2 className="h2 mt-5 text-ink">Before you reach out</h2>
            <p className="mt-5 text-lg text-slate-600">Quick answers to the questions we hear most often.</p>
          </div>
          <FaqList items={FAQS} />
        </div>
      </section>
    </>
  );
}
